import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core'
import { createUploadLink } from 'apollo-upload-client'
import 'whatwg-fetch'
import csrf from '@/common/utils/csrf'
import { handleExpireSessionError } from '@/common/utils/common'

const {
  headerKey,
  csrfToken
} = csrf()
const showError = handleExpireSessionError()
const patchFetch = async (...args: any[]) => {
  const [resource, config] = args
  const response = await fetch(resource, config)
  if (!response.ok && response.status === 422) {
    showError()
  }
  return response
}

// HTTP connection to the API
const url = window.location
const uri = `${url.protocol}//${url.host}/graphql`
const httpLink = createHttpLink({
  // You should use an absolute URL here
  uri: uri,
  fetch: patchFetch,
  headers: {
    [headerKey]: csrfToken
  }
})

// Cache implementation
const cache = new InMemoryCache()

// Create the apollo client
export const apolloClient = new ApolloClient({
  link: httpLink,
  cache
})

export const apolloUploadClient = new ApolloClient({
  //@ts-ignore
  link: createUploadLink({
    uri: uri,
    fetch: patchFetch,
    headers: {
      [headerKey]: csrfToken
    }
  }),
  cache
})
